<template>
  <div>
    <div v-if="!order" class="text-center">

      <h1 class="my-5 font-weight-light">Fulfill Order</h1>

      <div class="card border-0 shadow-sm" style="max-width:200px;margin:0 auto;">
        <div class="card-body">
          <form method="post" @submit.prevent="fetchOrder">
            <div class="form-group">
              <label for="inputOrderId">Order ID</label>
              <input v-model="orderId" type="text" class="form-control form-control-lg text-center" id="inputOrderId" placeholder="" required>
            </div>
            <button type="submit" class="btn btn-lg btn-primary" :disabled="fetchingOrder">
              <i v-if="fetchingOrder" class="fas fa-circle-notch fa-spin"></i>
              Fulfill Order
            </button>
          </form>
        </div>
      </div>

    </div>
    <template v-else>

      <div class="row">
        <div class="col-lg-9 col-xxl-7 offset-xxl-1 py-3 d-print-none">

          <h2 class="mb-3">
            Fulfill Order: {{ orderId }}
            <button v-if="order" class="btn btn-primary ml-2" @click.prevent=""><i class="fas fa-print"></i> Invoice</button>
          </h2>

          <order-information :order="order"></order-information>

          <div class="card border-0 shadow-sm table-responsive">
            <order-products :order="order" :prompt_assign_barcodes="true"></order-products>
          </div>

        </div>
        <div class="col-lg-3 col-xxl-3 py-3">

          <order-history></order-history>

        </div>
      </div>

    </template>
  </div>
</template>

<script>
import axios from 'axios'
import OrderInformation from './partials/Information'
import OrderHistory from './partials/History'
import OrderProducts from './partials/Products'

export default {
  name: 'OrderFulfill',
  components: {
    OrderProducts,
    OrderHistory,
    OrderInformation,
    axios
  },
  props: ['order_id'],
  data () {
    return {
      fetchingOrder: false,
      orderId: this.order_id,
      order: null,
      printUrl: null
    }
  },
  created () {
    if (this.order_id) {
      this.fetchOrder()
    }
  },
  methods: {
    fetchOrder () {
      return this.$router.push({ name: 'order.view', params: { order_id: this.orderId.replace(/[^0-9+]/, '') } })

      /* this.fetchingOrder = true

      axios.get('/orders/' + this.orderId).then((response) => {
        let order = response.data.data

        if (!order.order_status.code) {
          this.$toast.error('This order has an invalid status: ' + order.order_status.name)
          return false
        }

        this.order = order
        this.printUrl = process.env.URLS_WEBSITE + '/orders/' + this.orderId + '/print?hash=' + order.hash
      }).catch(error => {
        let errorDescription = null

        if (error.response) {
          if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.message !== 'undefined') {
            errorDescription = error.response.data.message
          }
        } else {
          errorDescription = error.message
        }

        this.$toast.error(errorDescription || 'Failed to fetch the order')
      }).finally(() => {
        this.fetchingOrder = false
      }) */
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/Fulfill.vue